import { render, staticRenderFns } from "./PToolbarButton.vue?vue&type=template&id=31dfe424"
import script from "./PToolbarButton.vue?vue&type=script&lang=js"
export * from "./PToolbarButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports